debounce = (fnc, delay) ->
  delayed = undefined
  (e) ->
    clearTimeout delayed
    delayed = setTimeout((->
      fnc e
      return
    ), delay)
    return

$ ->
  # Aufklapper Hauptnavigation
  # DoH
  $navlist_trigger  = $('.topnav__item')
  $navlist_trigger_mobile  = $('.trigger', '.topnav__item')

  if device.desktop()
    $navlist_trigger.hover (->
      $el = $(this)
      $el.addClass 'topnav__item--act'
      return
    ), ->
      $el = $(this)
      $el.removeClass 'topnav__item--act'
      return
    return
  else
    $navlist_trigger_mobile.on 'click', (e) ->
      $parent = $(this).parent()
      if $parent.find('.popup').length is 0
        return true
      if $parent.hasClass('topnav__item--act') is false
        $parent.addClass 'topnav__item--act'
        e.preventDefault()
        return false

$ ->
  # bind custom event
  $('.topnav__item').on 'ekvw:peekaboo', (e) ->
    $el = $(this)
    $el.addClass 'topnav__item--act'
    $el.data 'timeout', setTimeout($.proxy((->
      $el.removeClass 'topnav__item--act'
      return
    ), $el), 3e3)

  # react on click
  $('[data-persist-state=true]').bind 'click', (e) ->
    uid = this.dataset.persistUid.toString()
    # persist element uid to sessionStorage
    sessionStorage.setItem('persisted-navigation', uid)

  # get the persisted uid from sessionStorage
  persistedUid = parseInt(sessionStorage.getItem('persisted-navigation'))

  # if persistedUid is a valid uid…
  if persistedUid > 0
    # …trigger custom event
    $('.topnav__item[data-persist-uid='+persistedUid+']').trigger 'ekvw:peekaboo'

  # remove key from sessionStorage
  sessionStorage.removeItem('persisted-navigation')

$ ->
  popupWidth = 350
  elements = document.querySelectorAll('.topnav__item')

  reversePopup = (elements, popupWidth) ->
    screenWidth = window.innerWidth
    Array::forEach.call elements, (el, i) ->
      if screenWidth - (el.offsetLeft + popupWidth) < 0
        el.classList.add 'reverse-popup'
      else
        el.classList.remove 'reverse-popup'

  reversePopup(elements, popupWidth)

  $(window).on 'resize', debounce(((e) ->
    reversePopup(elements, popupWidth)
    return
  ), 30)



// WEBPACK FOOTER //
// ./Components/navigation.coffee